import { ActionTypes } from '../constants/ActionTypes';
import { AnyAction } from 'redux';
import { IUserInfo } from '../models/IUserInfo';

export function SetProfileInfo(info: IUserInfo): AnyAction {
    return {
        type: ActionTypes.SET_PROFILE_INFO,
        payload: info
    }
}


// WEBPACK FOOTER //
// ./src/actions/IdentityActions.tsx